<template>
  <div>
    <form novalidate class="md-layout" @submit="addCommitment(form.title, form.details, form.dueDate, form.email)">
      <md-card class="md-layout-item md-size-50 md-small-size-100 ">
        <md-card-header>
          <div class="md-title">Commitment</div>
        </md-card-header>

        <md-card-content>

          <md-field>
            <md-input v-model="form.title" required></md-input>
            <span class="md-helper-text">What are you committing to?</span>
            <span class="md-error">There is an error</span>
          </md-field>

          <md-field>
            <md-textarea v-model="form.details" md-autogrow md-counter="200"></md-textarea>
            <span class="md-helper-text">Add some details</span>
            <span class="md-error">There is an error</span>
          </md-field>

        <md-field >
          <md-datepicker v-model="form.dueDate" required/>
           <span class="md-helper-text">When is it due?</span>
        </md-field>

        <md-field :class="getValidationClass('email')">
          <label for="email">Email</label>
          <md-input type="email" name="email" id="email" autocomplete="email" v-model="form.email" />
          <span class="md-error" v-if="!$v.form.email.required">The email is required</span>
          <span class="md-error" v-else-if="!$v.form.email.email">Invalid email</span>
          <span class="md-helper-text">Who are you making the commitment to?</span>
        </md-field>

      </md-card-content>

      <!-- <md-progress-bar md-mode="indeterminate" v-if="sending" /> -->

      <md-card-actions>
        <md-button type="submit" class="md-primary" >Make Commitment</md-button>
      </md-card-actions>
    </md-card>

<!--     <md-snackbar :md-active.sync="userSaved">The user {{ lastUser }} was saved with success!</md-snackbar>
 -->  </form>
</div>
</template>

<script>
import { db } from '../main'
import { validationMixin } from 'vuelidate'
import {
  required,
  email,
  minLength
} from 'vuelidate/lib/validators'
import firebase from 'firebase'

export default {
  name: 'FormValidation',
  mixins: [validationMixin],
  data: () => ({
    form: {
      title: null,
      details: null,
      dueDate: null,
      email: null
    }
  }),
  validations: {
    form: {
      title: {
        required,
        minLength: minLength(3)
      },
      dueDate: {
        required,
        minLength: minLength(10)
      },
      email: {
        required,
        email
      }
    }
  },
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    clearForm () {
      this.$v.$reset()
      this.form.title = null
      this.form.details = null
      this.form.dueDate = null
      this.form.email = null
    },
    addCommitment (title, details, dueDate, email) {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        var user = firebase.auth().currentUser
        var userdoc = db.collection('user').doc(user.uid)

        const createdAt = new Date()
        userdoc.collection('commitment').add({ title, details, dueDate, email, createdAt })
        this.$router.replace('commitments')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}
.card-expansion {
}

.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/MakeCommitment.vue